// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 8\"><path fill=\"currentColor\" d=\"M13.36 4.219L9.694 7.883V4.89H.735V3.539h8.96L9.703.555l3.656 3.664z\"/></svg>";
// Exports
module.exports = code;